export function highlight_syllable(
  svg: SVGSVGElement,
  syllableIndex: number,
  textElementAttributes: { [key: string]: string },
) {
  const allTextElements = svg.querySelectorAll('text.syllable, .syllable text');
  if (allTextElements) {
    allTextElements.forEach((syllable) => {
      if (syllable.parentElement?.classList.contains('nabc-nueme')) {
        return;
      }
      for (const key in textElementAttributes) {
        if (syllable.getAttribute(key) !== '#ffffff') {
          syllable.setAttribute(key, '#000000');
        } else if (syllable.getAttribute(key) !== '#000000') {
          syllable.setAttribute('stroke', '#000000');
        }
        // syllable.removeAttribute(key);
      }
    });
  }
  const textElements = svg.querySelectorAll(`text.syllable-${syllableIndex}, .syllable-${syllableIndex} text`);
  if (textElements) {
    textElements.forEach((syllable) => {
      for (const key in textElementAttributes) {
        if (syllable.getAttribute(key) === '#000000') {
          syllable.setAttribute(key, textElementAttributes[key]);
        } else if (syllable.getAttribute(key) === '#ffffff') {
          syllable.setAttribute('stroke', textElementAttributes[key]);
        }
      }
    });
  }
}
